import {Component, input, output} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {TableModule} from 'primeng/table';
import {MailTemplateSummary} from '../../../../../../../api';
import {ElciaButton} from '../../../../../../components/buttons/button/button';
import {Loader} from '../../../../../../components/loader/loader';

@Component({
  selector: 'elcia-mail-template-grid',
  imports: [TableModule, TranslatePipe, ElciaButton, Loader],
  templateUrl: './mail-template-grid.html',
})
export class MailTemplateGrid {
  mailTemplates = input<MailTemplateSummary[]>([]);
  isLoading = input<boolean>(false);
  onEdit = output<MailTemplateSummary>();
  onDelete = output<MailTemplateSummary>();

  protected edit(row: MailTemplateSummary): void {
    this.onEdit.emit(row);
  }

  protected delete(event: Event, row: MailTemplateSummary): void {
    event.stopPropagation();
    this.onDelete.emit(row);
  }
}
